import produce from 'immer';

/**
 * Array内の全てのアイテムのselectedをfalseに戻す
 * @param {ReadonlyArray<T>} array
 * @returns {ReadonlyArray<T>}
 */
export const deselectAllElementsInArray = <T extends { selected: boolean }>(
  array: ReadonlyArray<T>,
): ReadonlyArray<T> =>
  array.map((element) =>
    produce(element, (draft) => {
      draft.selected = false;
    }),
  );
